<template lang="html">
  <v-dialog v-model="showDialog" persistent max-width=450>
    <v-card>
        <v-card-title class="headline">Shelter basic DEMO verzió</v-card-title>
        <v-card-text>
          <p class="subtitle">
            Ez az oldal kizárólag demonstrációs célokat szolgál!
          </p>
          <p>
            Az oldal szerkesztése,újítása folyamatos, a feltöltött adatok bármikor törlésre kerülhetnek!
          </p>
          <p>
            Az oldal kipróbálásához szükséges információkat a navigációs menüsorban, a "DEMO" fülön találja.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeDialog">Értettem!</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
export default {
  props:['showDialog'],
  methods:{
    closeDialog(){
      this.$emit('closeDemo')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
